import * as React from 'react';

import { Toggle, ToggleButtonGroup } from '@rematter/ui-web';
import { useAtom, useSetAtom } from 'jotai';

import { $direction, $offset } from '../../../_state/transactions.state';
import { useTranslations } from '../../../i18n/useTranslations';
import { TransactionDirection } from '../../../types/transaction';

//
// ⚛️ ⚛️ ⚛️ DIRECTION TOGGLE ⚛️ ⚛️ ⚛️
//
export const DirectionToggle = () => {
  const t = useTranslations();

  // Atoms
  const [direction, setDirection] = useAtom($direction);
  const setOffset = useSetAtom($offset);

  // Callbacks
  const handleDirectionChange = React.useCallback(
    (keys: Set<React.Key>) => {
      const first = [...keys][0];
      if (first) {
        setDirection(first as TransactionDirection);
        setOffset(0);
      }
    },
    [setDirection, setOffset],
  );

  return (
    <ToggleButtonGroup
      selectionMode="single"
      selectedKeys={new Set([direction])}
      onSelectionChange={handleDirectionChange}
      className="@DirectionToggle"
    >
      <Toggle id="inbound">{t.transactionsView.inbound}</Toggle>
      <Toggle id="outbound">{t.transactionsView.outbound}</Toggle>
    </ToggleButtonGroup>
  );
};
